<div class="question">
  <div class="number">{{(index||0) + 1}}.</div>
  <div class="text-container" *ngIf="!editMode">
    <div class="text">{{question.text}}</div>
    <div class="constraints"
         *ngIf="question.type.techId === QUESTION_TYPES.MULTIPLE_ANSWER && (question.minAnswers != null || question.maxAnswers != null)">
      <span>
        <ng-container *ngIf="question.minAnswers != null && question.maxAnswers != null">
          Количество вариантов: от {{question.minAnswers}} до {{question.maxAnswers}}
        </ng-container>
        <ng-container *ngIf="question.minAnswers != null && question.maxAnswers == null">
          Минимум вариантов: {{question.minAnswers}}
        </ng-container>
        <ng-container *ngIf="question.minAnswers == null && question.maxAnswers != null">
          Максимум вариантов: {{question.maxAnswers}}
        </ng-container>
      </span>
    </div>
    <div class="buttons" *ngIf="!readonly">
      <button mat-icon-button
              matTooltip="Редактировать"
              (click)="onEdit($event)">
        <mat-icon>edit</mat-icon>
      </button>
      <button mat-icon-button
              matTooltip="Удалить вопрос"
              (click)="onDelete($event)">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>
  <div class="upload-image-box" *ngIf="question.imageFile">
    <img [src]="question.imageFile">
  </div>
  <div *ngIf="editMode">
    <label>Изменить изображение к вопросу</label>
    <br />
    <input #imageInput
           type="file"
           accept="image/*"
           (change)="uploadImageFile(imageInput)">
    <button mat-icon-button
            matTooltip="Удалить изображение"
            (click)="deleteLoadedImage()">
      <mat-icon style="display: inline">delete</mat-icon>
    </button>
  </div>
  <form class="editor" *ngIf="!readonly && editMode"
        [formGroup]="form" (ngSubmit)="onSubmit($event)">
    <mat-form-field>
      <mat-label>Вопрос</mat-label>
      <textarea #input matInput formControlName="text"
                placeholder="Введите вопрос"
                [autofocus]="['autofocus']"
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="5"></textarea>
    </mat-form-field>
    <div class="buttons">
      <button mat-icon-button
              matTooltip="Сохранить"
              type="submit"
              (click)="onSubmit($event)">
        <mat-icon>done</mat-icon>
      </button>
      <button mat-icon-button
              matTooltip="Отмена"
              type="button"
              (click)="onCancel($event)">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
      <mat-radio-group *ngIf="question.type.techId !== QUESTION_TYPES.TEXT_ANSWER && testType!=='ISTQB'" formControlName="type" >
      <mat-radio-button *ngFor="let questionType of questionTypesToChange"
                        value="{{questionType.techId}}"
                        matTooltip="{{questionType.description}}"
                        [checked]="question.type.techId == questionType.techId"
                        (change)="onQuestionTypeChange(questionType.techId)">
        {{questionType.name}}
      </mat-radio-button>
    </mat-radio-group>
    <div class="min-max-controls" *ngIf="form.controls.type.value === QUESTION_TYPES.MULTIPLE_ANSWER">
      <mat-form-field>
        <mat-label>Минимальное количество ответов</mat-label>
        <input matInput type="number" min="0" formControlName="minAnswers" placeholder="0">
        <mat-error *ngIf="form.controls.minAnswers.hasError('min')">
          Значение не может быть меньше 0
        </mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Максимальное количество ответов</mat-label>
        <input matInput type="number" min="0" formControlName="maxAnswers" placeholder="Например, 3">
        <mat-error *ngIf="form.controls.maxAnswers.hasError('min')">
          Значение не может быть меньше 0
        </mat-error>
        <mat-error *ngIf="form.controls.maxAnswers.hasError('minGreaterThanMax')">
          Минимум не может быть больше максимума
        </mat-error>
      </mat-form-field>
    </div>
    <mat-radio-group formControlName="category" *ngIf="testType=='ISTQB'">
      <mat-radio-button *ngFor="let category of categories | keyvalue"
                        value="{{category.key}}"
                        matTooltip="{{category.value}}"
                        [checked]="question.category == category.key"
                        (change)="onQuestionCategoryChange(category.key)">
        {{category.value}}
      </mat-radio-button>
    </mat-radio-group>
  </form>
</div>
<div class="answers" [ngSwitch]="question.type.techId">

  <app-answer-options-editor *ngSwitchCase="QUESTION_TYPES.SINGLE_ANSWER"
                             [readonly]="readonly"
                             [testId]="testId"
                             [testType]="testType"
                             [questionId]="question.id"
                             [options]="question.options"
                             [multiple]="false"
                             [editMode]="editMode"
                             [question]="question"></app-answer-options-editor>

  <app-answer-options-editor *ngSwitchCase="QUESTION_TYPES.MULTIPLE_ANSWER"
                             [readonly]="readonly"
                             [testId]="testId"
                             [testType]="testType"
                             [questionId]="question.id"
                             [options]="question.options"
                             [multiple]="true"
                             [editMode]="editMode"
                             [question]="question"></app-answer-options-editor>

  <app-answer-text-edit-form *ngSwitchCase="QUESTION_TYPES.TEXT_ANSWER"
                             [readonly]="readonly"
                             [testId]="testId"
                             [questionId]="question.id"
                             [answer]="question.answer"></app-answer-text-edit-form>

</div>
